import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '../../../services/loader.service';
import { Observable } from 'rxjs/Rx';
import { CommunitymanagerService } from '../cm-dashboard/communitymanager.service';
import { LeadService } from '../../lead/lead.service';
import { DesignerService } from '../../designer/designer.service';
import { Routes, RouterModule , Router,ActivatedRoute} from '@angular/router';
import { CategoryPipe } from '../../../shared/category.pipe';
import { SortPipe } from '../../../shared/sort.pipe';
import { NgPipesModule } from 'ngx-pipes';
import { SchedulerService } from '../../scheduler/scheduler.service';
declare var $:any;

@Component({
  selector: 'app-cm-mapping',
  templateUrl: './cm-mapping.component.html',
  styleUrls: ['./cm-mapping.component.css'],
  providers: [CommunitymanagerService,SchedulerService,DesignerService,LeadService]
})
export class CmMappingComponent implements OnInit {
  
  cmTagList:any;
  tagList:any;
  cmList:any;
  errorMessage : string;
  erroralert = false;
  successalert = false;
  flag_change = false;
  successMessage : string;
  rowList:any;
  colList:any;
  hashTag:any ={};
  hashTag1:any ={};
  tag_list=[];
  fileName : string;
  downloadFileUrl: string;

  constructor(
  	private loaderService : LoaderService,
    private cmService : CommunitymanagerService,
    private leadService: LeadService,
    private formBuilder:FormBuilder,
    private schedulerService : SchedulerService,
    private designerService:DesignerService,
    private route:ActivatedRoute,
    private router: Router
  	) { }

  ngOnInit() {
  	this.getCmTags();
    this.getAllCmList();
    this.getAllTags();
    this.getRepopulate();
  }
  
  getCmTags(){
  	this.cmService.getCmTags().subscribe(res=>{
      this.rowList = res.cm_tag_mapping;
      for(let obj of this.rowList){
        this.hashTag1[obj.cm_id] = obj.tags
      }
      

  	},
  	err=>{
      
  	});
  }
  getAllCmList(){
    this.cmService.getAllCmList().subscribe(res=>{
      
    },
    err=>{
      
    });

  }
  getRepopulate(){
    for(let obj of this.rowList){

    }
  }
  
  getAllTags(){
    this.cmService.getAllTags('lead').subscribe(res=>{

      this.colList = res.tags.filter(tag => tag.humanized_name !== "Both");

    },
    err=>{
      
    });

  }

  downloadFile(){
    this.cmService.downloadFile().subscribe(res=>{
      this.fileName = res.file_name;
      this.cmService.downloadFileAPICall(this.fileName);
    },
    err=>{
      
    });
  }
  
  restructureHash(event,cmId,tagId){
    var hash_key=Object.keys(this.hashTag1);
    if(event.target.checked == true){
      if(hash_key.includes(cmId.toString())){
        
        // this.tag_arr.push(tagId);
        // 
        (this.hashTag1[cmId]).push(tagId);
        // 
        // this.hashTag1[cmId]= x;
      }
      else{
        var tag_arr=[];
        tag_arr.push(tagId)
        this.hashTag1[cmId]= tag_arr;

      }

    }
    else{
      let index = this.hashTag1[cmId].indexOf(tagId);
       
       this.hashTag1[cmId].splice(index,1);
    }

    


   


  }
  submitMapping(){
    this.loaderService.display(true);
    this.cmService.submitTags(this.hashTag1).subscribe(
      res=>{
      this.loaderService.display(false);
       this.successalert = true;
      this.successMessage = 'Mapping Submitted successfully';
      setTimeout(function() {
           this.successalert = false;
      }.bind(this), 5000);
      

    },
    err=>{
      
    });


  }
  restructureDesignStudio(event,cmId){
    if (event.target.checked) {
      if (confirm("Do you really want to assign this CM as design studio CM ? ")) {
        console.log(event,cmId,'cmId');
        this.loaderService.display(true);
        this.cmService.assignAsDesignStudio(cmId,'active').subscribe(
          res=>{
          this.loaderService.display(false);
          this.successalert = true;
          this.successMessage = 'Selected community manager assigned as a design studio';
          this.getCmTags();
          this.getAllCmList();
          this.getAllTags();
          this.getRepopulate();
          setTimeout(function() {
               this.successalert = false;
          }.bind(this), 5000);
        },
        err=>{
          this.loaderService.display(false);
          this.erroralert = true;
          this.errorMessage = <any>JSON.parse(err['_body']).message;
          setTimeout(function() {
               this.erroralert = false;
          }.bind(this), 5000);
        });

      } else {
        $("#box-"+cmId).prop('checked',false);
        this.getCmTags();
        false;
      }
    }else{
      if (confirm("Do you really want to unassigned this CM as design studio CM ?")) {
        console.log(event,cmId,'cmId');
        this.loaderService.display(true);
        this.cmService.assignAsDesignStudio(cmId,'inactive').subscribe(
          res=>{
          this.loaderService.display(false);
          this.successalert = true;
          this.successMessage = 'Selected community manager unassigned as a design studio';
          this.getCmTags();
          this.getAllCmList();
          this.getAllTags();
          this.getRepopulate();
          setTimeout(function() {
               this.successalert = false;
          }.bind(this), 5000);
        },
        err=>{
          this.loaderService.display(false);
          this.erroralert = true;
          this.errorMessage =<any>JSON.parse(err['_body']).message;
          setTimeout(function() {
               this.erroralert = false;
          }.bind(this), 5000);
        });
      } else {
        $("#box-"+cmId).prop('checked',false);
        this.getCmTags();
        false;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/platform/organisation/cm-mapping/cm-mapping.component.ts